'use strict';

const fitAnalytics = require('fitAnalytics/fitAnalytics/fitAnalyticsFunctions');
const csrf = require('cisalfa/csrf/csrf');
const productHelpers = require('./productHelpers');

let location = window.location;
const alertMessage = require('../utils/alertMessage');
const minicartPanel = require('../utils/minicartPanel');

// Modals with an add to cart button, closed as soon as the add to cart starts
const ADD_TO_CART_MODALS = '.js-quickview-modal, .js-modal-pset, .js-wishlist-edit';

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    let pid;

    if (($('#quickViewModal').hasClass('show') || $('#editProductModal').hasClass('show')) && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    if (!pid) {
        pid = $($el).data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    let quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        let quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        let quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var safeValue = $.escapeSelector(attrValue.value);
        var selector = '[data-attr="' + attr.id + '"] [data-attr-value="' + safeValue + '"]';
        let $attrValue = $productContainer.find(selector);

        let $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.parent().attr('aria-checked', 'true');
        } else {
            $attrValue.removeClass('selected');
            $attrValue.parent().attr('aria-checked', 'false');
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        }

        // Disable if not selectable
        $attrValue.closest('.js-size-attribute').removeClass('cc-available cc-unavailable');
        $attrValue.closest('.js-size-attribute').find('.js-quickview__size-swatch').removeClass('cc-available cc-unavailable');

        $attrValue.closest('.js-size-attribute').addClass(attrValue.selectable ? 'cc-available' : 'cc-unavailable');
        $attrValue.closest('.js-size-attribute').find('.js-quickview__size-swatch').addClass(attrValue.selectable ? 'cc-available' : 'cc-unavailable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    let $attr = '[data-attr="' + attr.id + '"]';
    let $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        let $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    let attrsWithSwatches = ['color', 'size'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    let availabilityValue = '';
    let availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    let html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-option').empty().html(optionsHtml);
}

function createSlickCarousel(imgs, $productContainer, slideClasses, imgClasses) {
    let slickContainer = $productContainer.find('.js-slider');
    if (slickContainer && slickContainer.length) {
        $(slickContainer).slick("unslick");
        $(slickContainer).empty();
    }

    let isQuickView = $productContainer.closest('#quickViewModal').length > 0;

    for (let i = 0; i < imgs.length; i++) {
        let image = imgs[i];
        let slideDiv = $('<div class="' + slideClasses + '"></div>');
        let productImage = $('<div class="cc-product-image"></div>');
        if (!imgClasses) {
            imgClasses = '';
        }
        let imgSrc = isQuickView ? (image.tileUrl || image.url) : image.url;
        let imgElement = $('<img src="' + imgSrc + '" class="' + imgClasses +'" alt="' + image.alt + ' - ' + image.index + '" itemprop="image" aria-hidden="true" />');

        imgElement.appendTo(productImage);
        productImage.appendTo(slideDiv);
        slideDiv.appendTo(slickContainer);
    }

    if ($('.js-pdp-slider-img').length > 0) {
        const mainImageNumber = $('.js-pdp-slider-img .cc-pdp__image-wrp').length;

        if (mainImageNumber % 2 > 0) {
            $('.js-pdp-slider-img').addClass('cc-pdp__slider--first-big');
        } else {
            $('.js-pdp-slider-img').removeClass('cc-pdp__slider--first-big');
        }
    }

    slickContainer.slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        autoplay: false,
        responsive: [{
            breakpoint: 1198.98,
            settings: "unslick"
        }]
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer, isSizeAttribute = false) {
    let isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    let isVaraint;
    if (response.product.variationAttributes) {
        
        // Handle size blinking when automatically changed
        let previousSelectedSize = $productContainer.data('previous-selected-size');

        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        
        // If color changed and size was automatically changed
        if (!isSizeAttribute && previousSelectedSize) {
            let $sizeContainer = $productContainer.find('[data-attr="size"]');
            let currentSelectedSize = $sizeContainer.find('.selected').data('attr-value');
            
            // Always remove class before checking
            $sizeContainer.find('.js-size-attribute').removeClass('cc-size-auto-selected');
            
            if (currentSelectedSize && currentSelectedSize !== previousSelectedSize) {
                $sizeContainer.find('.selected').closest('.js-size-attribute').addClass('cc-size-auto-selected');
            }
            $productContainer.removeData('previous-selected-size');
        }

        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    if (!isSizeAttribute) {
        let primaryImageUrls = response.product.images.large;
        let slideClasses = $($productContainer).find('.js-zoom-image-wrap').attr('class');
        let imgClasses = $($productContainer).find('.js-zoom-image').attr('class');
        createSlickCarousel(primaryImageUrls, $productContainer, slideClasses, imgClasses);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        let $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);
    $productContainer.find('.js-wishlist-heart').empty().html(response.product.wishlistHeartHtml);
    $productContainer.find('.js-dropshipping-delivery').empty().html(response.product.dropshippingDeliveryHtml);
    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        let $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    // Update promo storefront
    if(response.product.cisalfa_td_promo_storefront && productHelpers.handlePromoStorefrontValue(response.product.cisalfa_td_promo_storefront)){
        $('.cc-pdp__labels .js-promo-storefront').text(response.product.cisalfa_td_promo_storefront).removeClass('d-none');
        $('.cc-quickview__labels .js-promo-storefront').text(response.product.cisalfa_td_promo_storefront).removeClass('d-none');
    } else{
        $('.cc-pdp__labels .js-promo-storefront').text('').addClass('d-none');
        $('.cc-quickview__labels .js-promo-storefront').text('').addClass('d-none');
    }
     
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        let optionsHtml = quantities.map(function (quantity) {
            let selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"'
                + selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the iframe url for find in storewhen a product attribute is selected or deselected
 */
function updateFindInStoreUrl() {
    const $modal = $('#modalFindInStore');
    if ($modal.length === 0) return;

    const $iframe = $modal.find('iframe');
    let dataSrc = $iframe.attr('data-src');
    if (!dataSrc) return;

    let [urlPart1, urlPart2] = dataSrc.split('value=');
    urlPart1 += 'value=';
    if ($('#product-id-sku').length > 0) {
        urlPart2 = $('#product-id-sku').text();
    }
    dataSrc = urlPart1 + urlPart2;

    $iframe.attr('data-src', dataSrc);

    // If modal is already open, update src immediately
    if ($modal.hasClass('show')) {
        $iframe.attr('src', dataSrc);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer, isSizeAttribute = false) {
    if (selectedValueUrl) {
        $('body').trigger(
            'product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer }
        );

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer, isSizeAttribute);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger(
                    'product:afterAttributeSelect',
                    { data: data, container: $productContainer, isSizeAttribute: isSizeAttribute }
                );
                updateFindInStoreUrl();

                // update data for fitAnalytics
                fitAnalytics.updatePdpDataObject();

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    let $html = $('<div>').append($.parseHTML(html));

    let body = $html.find('.choice-of-bonus-product');
    let footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    let bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    let htmlString =
        '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message cc-visibility-hidden" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="cc-visibility-hidden"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            let parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .cc-visibility-hidden').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    let messageType = response.error ? 'cc-alert--danger' : 'cc-alert--success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else if (!minicartPanel.opensOnAddToCart(response)) {
        // When enabled, a successful add to cart is confirmed by the minicart panel instead
        alertMessage(response.message, messageType, true);
    }
}

/**
 * Shows the generic error alert when an add to cart could not be completed
 * (network/server error, CSRF token not available)
 */
function showAddToCartError() {
    alertMessage($('.js-alert-message').data('error-text'), 'cc-alert--danger');
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    let childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    let options = $productContainer
        .find('.product-option')
        .map(function () {
            let $elOption = $(this).find('.options-select.selected');
            let urlValue = $elOption.val();
            let selectedValueId = $elOption.data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * Send Analytics Event for B2C App && GA4
 */
function sendAnalyticsEvent(e, product) {
    const CONSTANTS = require('../ga4/constants/constants')

    if (typeof dataLayer !== 'undefined' && typeof window.analyticsWrapper === 'function' && !e) {
        try {
            window.analyticsWrapper('addToCart', {
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {
                        'products': [{
                            'name': product.productName,
                            'id': product.productID,
                            'SKU': product.prodSKU,
                            'price': product.productPrice, //valore prodotti aggiunti di questo SKU lordo tasse
                            'brand': product.productBrand, // brand
                            'category': product.productCategory, // primary Category associata al prodotto
                            'quantity': 1,
                            'item_sku': product.item_sku,
                            'item_sku_variation': product.item_sku_variation,
                            'item_category': product.item_category,
                            'item_category2': product.item_category2,
                            'item_category3': product.item_category3,
                            'item_category4': product.item_category4,
                        }]
                    }
                }
            });
        }
        catch (error) {
            console.error('Error: impossible to send event addToCart');
        }
    }

    try {
        //Attach GA4 analytics by triggering event
        if (e) {
            let $buttonElement = $(e.currentTarget);
            if ($buttonElement) {

                if (sessionStorage.getItem('selectSizeEvent')) sessionStorage.removeItem('selectSizeEvent');
                let color = $('.color-attribute .selected').data('attr-value');
                let size = $('.size-attribute .selected').data('attr-value');
                if ($buttonElement.hasClass('size-attribute')) {
                    size = $buttonElement.find('.size-value').data('attr-value')
                }
                if ($buttonElement.hasClass('color-attribute')) {
                    color = $buttonElement.find('.color-value').data('attr-value');
                }
                sessionStorage.setItem('selectSizeEvent', JSON.stringify({ color: color, size: size }))
                $(document).trigger(CONSTANTS.EVENT_CONSTANTS.PDP.EVENTS.SELECT_SIZE);
            }
        } else {
            if ($('body .js-ga4-dataset').data('analytics') === 'wishlist')
                $(document).trigger(CONSTANTS.EVENT_CONSTANTS.WISHLIST.EVENTS.ADD_PRODUCT);
            else
                $(document).trigger(CONSTANTS.EVENT_CONSTANTS.PDP.EVENTS.ADD_PRODUCT);
        }
    } catch (error) {
        console.error('Error: impossible to attach ga4 event: ' + error);
    }
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },
    findInStore: function () {
        $('#modalFindInStore').on('show.bs.modal', function () {
            const $iframe = $(this).find('iframe');
            const dataSrc = $iframe.attr('data-src');
            if (dataSrc && $iframe.attr('src') !== dataSrc) {
                $iframe.attr('src', dataSrc);
            }
        });
    },
    colorAttribute: function () {
        $(document).on('click', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            let $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            // Store currently selected size before color change
            let currentSelectedSize = $productContainer.find('[data-attr="size"] .selected').data('attr-value');
            $productContainer.data('previous-selected-size', currentSelectedSize);

            attributeSelect($(this).attr('data-url'), $productContainer);

            //AddToCart Details Data Layer per E-commerce
            sendAnalyticsEvent(e);
        });
    },

    selectAttribute: function () {
        $(document).on('click', '.js-size-attribute', function (e) {
            e.preventDefault();

            // The selected size carries the SFRA "deselect" URL (empty size param): requesting it
            // falls back to the default variant, so tapping the current size would reset it.
            if ($(this).find('.selected').length) {
                return;
            }

            let $productContainer = $(this).closest('.set-item');

            if (!$productContainer.length) {
                $productContainer = $(this).parents('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer, true);

            //AddToCart Details Data Layer per E-commerce
            sendAnalyticsEvent(e);
        });
    },

    selectAttributeOptions: function () {
        $(document).on("click", '.js-assembly-option', function (e) {
            e.preventDefault();
            $(".js-assembly-option").removeClass("selected");
            $(this).addClass('selected');
            // leave this comment for now 
            // let $productContainer = $(this).closest(".set-item");
            // if (!$productContainer.length) {
            //     $productContainer = $(this).closest(".product-detail");
            // }
            // attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect(
                    $(e.currentTarget).find('option:selected').data('url'),
                    $productContainer
                );
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', async function () {
            let addToCartUrl;
            let pid;
            let pidsObj;
            let setPids;

            // Single page-level spinner, also when adding from a modal (closed below)
            $.spinner().start();

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail') && !$(this).hasClass('product-tile')) {
                        setPids.push({
                            pid: $(this).find('.product-id').text(),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            let $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
                if (!$productContainer.length) {
                    $productContainer = $(this).closest('.js-product-card-wishlist');
                }
            }

            addToCartUrl = getAddToCartUrl();

            let quantity = '';
            if ($(this).parents('.cc-quickview__addtobutton-wrap')) {
                quantity = 1;
            } else {
                quantity = getQuantitySelected($(this));
            }
            let form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: quantity
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            if (!addToCartUrl) {
                $.spinner().stop();
                return;
            }

            // Adding from a modal (quickview, product set, wishlist edit): it closes on add to cart
            // anyway, so close it right away and keep only the page spinner until the outcome
            // (minicart panel or alert). Only now: getPidValue() above needs the quickview still open.
            // Closed right after the next paint, not inside the click: hiding a modal (Bootstrap and
            // a11y handlers, style and layout) would otherwise add to the interaction's INP.
            const $sourceModal = $(this).closest(ADD_TO_CART_MODALS);
            if ($sourceModal.length) {
                requestAnimationFrame(() => setTimeout(() => $sourceModal.modal('hide'), 0));
            }

            let csrf_token;
            try {
                csrf_token = await csrf.methods.getCsrfToken();
            } catch (err) {
                $.spinner().stop();
                showAddToCartError();
                return;
            }
            if(csrf_token && csrf_token.token){
                form.csrf_token = csrf_token.token;
            }

            $(this).trigger('updateAddToCartFormData', form);
            $.ajax({
                url: addToCartUrl,
                method: 'POST',
                data: form,
                success: function (data) {
                    handlePostCartAdd(data);
                    $('body').trigger('product:afterAddToCart', data);
                    $.spinner().stop();
                    miniCartReportingUrl(data.reportingURL);

                    //AddToCart Details Data Layer per E-commerce
                    sendAnalyticsEvent(null, data.analyticsData);
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                        return;
                    }
                    $.spinner().stop();
                    showAddToCartError();
                }
            });
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            let $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            let pid = $(this).data('pid');
            let maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            let submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            let totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            let optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            let valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                let selectedBonusProductHtml = ''
                    + '<div class="selected-pid row" '
                    + 'data-pid="' + pid + '"'
                    + 'data-qty="' + submittedQty + '"'
                    + 'data-optionID="' + (optionID || '') + '"'
                    + 'data-option-selected-value="' + (valueId || '') + '"'
                    + '>'
                    + '<div class="col-sm-11 col-9 bonus-product-name" >'
                    + $choiceOfBonusProduct.find('.product-name').html()
                    + '</div>'
                    + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
                    + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            let $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            let count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );
            let pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            let url = $(this).data('url');
            $('.modal-content').spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    let parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content').spinner().stop();
                },
                error: function () {
                    $('.modal-content').spinner().stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            let $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            let queryString = '?pids=';
            let url = $('.choose-bonus-product-dialog').data('addtocarturl');
            let pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                let qtyOption = parseInt($(this)
                    .data('qty'), 10);

                let option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.minicart .minicart-quantity').css('display', () => data.totalQty === 0 ? 'none' : 'inline-flex');
                        $('.minicart .minicart-quantity').html(data.totalQty);
                        // When enabled, the minicart panel opens as the bonus dialog closes and confirms the add to cart
                        if (!minicartPanel.isEnabled()) {
                            $('.add-to-cart-messages').append(
                                '<div class="alert alert-success cc-alert--success add-to-basket-alert text-center"'
                                + ' role="alert">'
                                + data.msgSuccess + '</div>'
                            );
                        }
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected,
    miniCartReportingUrl: miniCartReportingUrl,
    initGiftcardForms: function () {
        const FORM_SEL = '.js-giftcard-form';

        $(FORM_SEL).each(function () {
            const $form = $(this);
            if ($form.data('gc-inited')) return;
            $form.data('gc-inited', true);

            // lettura per-form del limite giorni
            const MAX_DAYS_AHEAD = parseInt($form.data('max-days-scheduled'), 10) || 365;
            const toISODate = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().split('T')[0];

            const sel = {
                radios: 'input[name="giftcardAmount"]',
                radioCustom: '#giftcardAmount-custom',
                customInput: '#giftcardAmount-customValue',
                sendNow: '#giftcardSendingProgramming-Now',
                sendAfter: '#giftcardSendingProgramming-After',
                sendDate: '#giftcardSendDate',
                dateWrap: '#giftcardDateWrapper',
                senderName: '#giftcardSenderName',
                recipientName: '#giftcardRecipientName',
                recipientEmail: '#giftcardRecipientEmail',
                message: '#giftcardMessage',
                cta: 'button.js-giftcard-add-to-cart'
            };

            // -------- helpers ----------
            const clearErrors = () => {
                $form.find('.is-invalid').removeClass('is-invalid').removeAttr('aria-invalid');
                $form.find('.cc-form__wrap--error').removeClass('cc-form__wrap--error');
                $form.find('.invalid-feedback.cc-message').empty();
            };

            const showError = (input, type) => {
            const $inp = $(input);
            let msg = '';
            if (type === 'missing') msg = $inp.data('missing-error') || '';
            else if (type === 'pattern') msg = $inp.data('pattern-mismatch') || '';
            else if (type === 'range') msg = $inp.data('range-error') || '';
            
            const errId = $inp.attr('aria-describedby');
            if (errId) $('#' + errId).text(msg);
                $inp.addClass('is-invalid').attr('aria-invalid', 'true');
                $inp.closest('.cc-form__wrap').addClass('cc-form__wrap--error');
            };

            // -------- init date min/max (timezone-safe) ----------
            $form.find(sel.sendDate).each(function () {
                const today = new Date(); today.setHours(0,0,0,0);
                const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
                const maxDate = new Date(today); maxDate.setDate(today.getDate() + MAX_DAYS_AHEAD);
                $(this).attr('min', toISODate(tomorrow)).attr('max', toISODate(maxDate));
            });

            // -------- show/hide date wrapper ----------
            const $after = $form.find(sel.sendAfter);
            const $now   = $form.find(sel.sendNow);
            const $date  = $form.find(sel.sendDate);
            const $wrap  = $form.find(sel.dateWrap);

            const showDate = () => {
            $wrap.removeAttr('hidden').attr('aria-hidden', 'false');
            $date.removeAttr('tabindex');
            };
            const hideDate = () => {
            $wrap.attr('hidden', 'hidden').attr('aria-hidden', 'true');
            $date.attr('tabindex', '-1').val('')
                .removeClass('is-invalid').removeAttr('aria-invalid')
                .closest('.cc-form__wrap').removeClass('cc-form__wrap--error');
            const errId = $date.attr('aria-describedby'); if (errId) $('#' + errId).empty();
            };
            const syncDateVisibility = () => ($after.is(':checked') ? showDate() : hideDate());

            const toggleCustomAmountState = () => {
                const $customRadio = $form.find(sel.radioCustom);
                const $customInput = $form.find(sel.customInput);
                if ($customRadio.is(':checked')) {
                    $customInput.prop('required', true).attr('aria-required', 'true')
                                .addClass('js-form-control')
                                .trigger('change');
                    
                } else {
                    $customInput
                                .val($customInput.attr('min') || '')
                                .trigger('change')
                                .prop('required', false).attr('aria-required', 'false')
                                .removeClass('is-invalid').removeAttr('aria-invalid')
                                .closest('.cc-form__wrap').removeClass('cc-form__wrap--error')
                                .removeClass('js-form-control');
                    $customInput.val('');
                    const errId = $customInput.attr('aria-describedby'); if (errId) $('#' + errId).empty();
                }
            };

            const toggleSendDateState = () => {
                if ($after.is(':checked')) {
                    $date.prop('required', true).attr('aria-required', 'true')
                        .addClass('js-form-control')
                        .trigger('change');
                } else {
                    $date.prop('required', false).attr('aria-required', 'false')
                        .trigger('change')
                        .removeClass('js-form-control')
                        .val('')
                        .removeClass('is-invalid').removeAttr('aria-invalid')
                        .closest('.cc-form__wrap').removeClass('cc-form__wrap--error');
                    const errId = $date.attr('aria-describedby'); if (errId) $('#' + errId).empty();
                }
                syncDateVisibility();
            };

            // -------- custom amount typing rules ----------
            // digits only; block exceeding max at type-time
            $form.on('keydown.gc', sel.customInput, function (e) {
                const $inp = $(this);
                const key = e.key;
                const control = ['Backspace','Delete','Tab','ArrowLeft','ArrowRight','Home','End','Escape','Enter'];
                if (control.includes(key)) return;

                if (/^[0-9]$/.test(key)) {
                    const max = parseInt($inp.attr('max'), 10);
                    const el = $inp.get(0);
                    const start = el.selectionStart ?? $inp.val().length;
                    const end   = el.selectionEnd ?? $inp.val().length;
                    const cur = ($inp.val() || '').toString();
                    const proposed = (cur.slice(0, start) + key + cur.slice(end)).replace(/\D/g, '');
                    if (!isNaN(max) && proposed !== '' && Number(proposed) > max) e.preventDefault();
                    return;
                }
                e.preventDefault();
            });

            // sanitize on input; auto-check radio custom if has digits
            $form.on('input.gc', sel.customInput, function () {
                const $input = $(this);
                const cleaned = ($input.val() || '').toString().replace(/\D/g, '');
                if ($input.val() !== cleaned) $input.val(cleaned);
                if (cleaned) $form.find(sel.radioCustom).prop('checked', true);
                toggleCustomAmountState();
            });

            // paste guard for max + sanitize
            $form.on('paste.gc', sel.customInput, function (e) {
                const $inp = $(this);
                const data = (e.originalEvent.clipboardData || window.clipboardData).getData('text') || '';
                const digits = data.replace(/\D/g, '');
                const max = parseInt($inp.attr('max'), 10);
                const el = $inp.get(0);
                const start = el.selectionStart ?? $inp.val().length;
                const end   = el.selectionEnd ?? $inp.val().length;
                const cur = ($inp.val() || '').toString();
                const proposed = (cur.slice(0, start) + digits + cur.slice(end)).replace(/\D/g, '');
                if (!isNaN(max) && proposed !== '' && Number(proposed) > max) {
                    e.preventDefault();
                } else {
                    setTimeout(() => {
                        const cleaned = ($inp.val() || '').toString().replace(/\D/g, '');
                        $inp.val(cleaned);
                        if (cleaned) $form.find(sel.radioCustom).prop('checked', true);
                        toggleCustomAmountState();
                    }, 0);
                }
            });

            // clear custom input when selecting a predefined radio
            $form.on('change.gc', sel.radios, function () {
                if (!$(this).is(sel.radioCustom)) {
                    $form.find(sel.customInput).val('');
                }
                toggleCustomAmountState();
            });

            // now/after radios -> toggle date required/visibility
            $form.on('change.gc', sel.sendNow + ', ' + sel.sendAfter, toggleSendDateState);

            // clear single field errors + re-evaluate CTA on user edits
            $form.on('input.gc change.gc', '.js-form-control', function () {
                const $inp = $(this);
                $inp.removeClass('is-invalid').removeAttr('aria-invalid').closest('.cc-form__wrap').removeClass('cc-form__wrap--error');
                const errId = $inp.attr('aria-describedby'); if (errId) $('#' + errId).empty();
            });

            // -------- submit handler (validazione funzionale + AJAX) ----------
            $form.on('submit.gc', function (e) {
                e.preventDefault();
                e.stopPropagation();
                clearErrors();

                const $checked = $form.find(sel.radios + ':checked');
                const isCustom = $checked.is(sel.radioCustom);
                const $custom  = $form.find(sel.customInput);

                const amountRaw = isCustom ? $custom.val() : ($checked.val() || '');
                const amount = (amountRaw || '').trim();

                const senderName = ($form.find(sel.senderName).val() || '').trim();
                const recipientName = ($form.find(sel.recipientName).val() || '').trim();
                const recipientEmail = ($form.find(sel.recipientEmail).val() || '').trim();
                const message = ($form.find(sel.message).val() || '').trim();

                const programAfter = $form.find(sel.sendAfter).is(':checked');
                const sendingDate = programAfter ? ($form.find(sel.sendDate).val() || '').trim() : '';

                // validate all required fields (show all errors at once)
                let hasError = false;
                const need = (jq, type) => { showError(jq[0], type); hasError = true; };

                if (!senderName)   need($form.find(sel.senderName), 'missing');
                if (!recipientName) need($form.find(sel.recipientName), 'missing');
                if (!recipientEmail) need($form.find(sel.recipientEmail), 'missing');

                if (!amount) need(isCustom ? $form.find(sel.customInput) : $checked, 'missing');
                if (isCustom) {
                    const n = Number(amount);
                    const min = parseInt($custom.attr('min'), 10);
                    const max = parseInt($custom.attr('max'), 10);
                    if (!Number.isFinite(n) || !Number.isInteger(n)) need($custom, 'pattern');
                    if ((!Number.isNaN(min) && n < min) || (!Number.isNaN(max) && n > max)) need($custom, 'range');
                }

                if (programAfter && !sendingDate) need($form.find(sel.sendDate), 'missing');

                if (hasError) return;

                const giftCardContext = $form.closest('.cc-giftcard-buy[data-analytics-name]').data('analyticsName') || 'categoria';

                const payload = {
                    giftCertRecipientName: recipientName,
                    giftCertEmail: recipientEmail,
                    giftCertSenderName: senderName,
                    giftCertSendingDate: sendingDate,
                    giftCertAmount: amount,
                    giftCertMessage: message,
                    giftCertAnalyticsContext: giftCardContext
                };

                const url = $form.data('action');
                if (!url) return;

                $.spinner && $.spinner().start && $.spinner().start();

                $.ajax({ type: 'POST', url, data: payload })
                    .done(function (data) {
                        if (typeof handlePostCartAdd === 'function') handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);

                        if (typeof window.analyticsWrapper === 'function' && data && data.analyticsData) {
                            try {
                                const giftCardAddToCartHelper = require('../analytics/helpers/giftCardAddToCartHelper');
                                const flutterPayload = giftCardAddToCartHelper.buildAddToCartPayload(data.analyticsData);
                                if (flutterPayload) {
                                    window.analyticsWrapper('addToCart', flutterPayload);
                                }
                            } catch (error) {
                                console.error('Error: impossible to send gift card addToCart to mobile app', error);
                            }
                        }

                        const sendNowChecked = $form.find(sel.sendNow).is(':checked');

                        $form[0].reset();
                        clearErrors();
                        
                        $('body').trigger('formValidation:clear', $form.attr('name'));

                        if (sendNowChecked) {
                            $form.find(sel.sendNow).prop('checked', true);
                        }

                        $form.find(sel.radios).first().prop('checked', true);
                        $form.find(sel.radios).trigger('change');

                        toggleSendDateState();

                        $form.find(sel.cta).addClass('cc-disabled').prop('disabled', true);
                    })
                    .always(function () {
                        $.spinner && $.spinner().stop && $.spinner().stop();
                    });
            });

            // -------- initial sync ----------
            toggleCustomAmountState();
            toggleSendDateState();
        });
    },

    giftCardCheckBalance: () => {
        // reset del modal "saldo gift card"
        $('body').on('hidden.bs.modal', '.js-modal-giftcard-check-balance', function () {
            const $results = $(this).find('.js-giftcard-balance-info');
            const $input = $(this).find('.js-gift-cart-check-balance-code');
            const $error = $(this).find('.js-giftcard-balance-error');
            const $expiration = $(this).find('.js-giftcard-check-balance-expiry-date');
            const $amount = $(this).find('.js-giftcard-check-balance-amount');
            const $available = $(this).find('.js-giftcard-check-balance-available-balance');
            const $btnCheck = $(this).find('.js-gift-cart-check-balance');
            $results.addClass('d-none');
            $error.addClass('d-none');
            $input.closest('.js-form-wrap').removeClass('cc-form__wrap--error');
            $input.val('').removeClass('is-invalid').removeAttr('aria-invalid');
            $btnCheck.addClass('cc-disabled').prop('disabled', true);
            $expiration.empty();
            $amount.empty();
            $available.empty();
        });

        $(document).off('submit.giftcard.balance')
        .on('submit.giftcard.balance', '.cc-giftcard-check-modal form[data-action]', function (evt) {
            evt.preventDefault();
            evt.stopPropagation();

            const $form = $(this);
            const $results = $(this).find('.js-giftcard-balance-info');
            const $error = $(this).find('.js-giftcard-balance-error');
            const $code = $form.find('.js-gift-cart-check-balance-code');
            const $submit = $form.find('button.js-gift-cart-check-balance');
            const $expiration = $form.find('.js-giftcard-check-balance-expiry-date');
            const $amount = $form.find('.js-giftcard-check-balance-amount');
            const $available = $form.find('.js-giftcard-check-balance-available-balance');
            const url = $form.attr('data-action');
            const codeVal = ($code.val() || '').trim();
            if (!codeVal) return;

            const payload = { giftCardCode: codeVal };

            // UI lock + spinner
            $submit.prop('disabled', true);
            if ($.spinner) $.spinner().start();
            $expiration.empty();
            $amount.empty();
            $available.empty();

            $.ajax({
                type: 'POST',
                url: url,
                data: payload
            })
            .done(function (data) {
                if (data && data.error) {
                    $expiration.empty();
                    $amount.empty();
                    $available.empty();
                    $error.html(data.message);
                    $results.addClass('d-none');
                    $error.removeClass('d-none');
                } else {
                    const bal = data && data.faceValue != null ? String(data.faceValue)  : '';
                    const rem = data && data.remainingValue != null ? String(data.remainingValue) : '';
                    const exp = data && data.expirationDate ? String(data.expirationDate) : '';
                    $expiration.text(exp);
                    $amount.text(bal);
                    $available.text(rem);
                    $results.removeClass('d-none');
                    $error.addClass('d-none');
                }
            })
            .always(function () {
                if ($.spinner) $.spinner().stop();
                $submit.prop('disabled', false);
            });
        });
    }
};
